'use strict';
exports.base64 = false;
exports.binary = false;
exports.dir = false;
exports.createFolders = true;
exports.date = null;
exports.compression = null;
exports.compressionOptions = null;
exports.comment = null;
exports.unixPermissions = null;
exports.dosPermissions = null;



//////////////////
// WEBPACK FOOTER
// ./~/jszip/lib/defaults.js
// module id = 436
// module chunks = 1